import React from "react";
import { useIntl } from "react-intl";
import { ChevronLeft, ChevronRight } from "react-feather";
import "./styles.scss";

const Pagination = ({ page, totalPages, setPage }) => {
  const { formatMessage } = useIntl();

  return (
    <nav className="pagination is-centered is-small" role="navigation">
      <button
        className="pagination-previous"
        title={formatMessage({ id: "pagina-anterior" })}
        disabled={page === 1}
        onClick={() => setPage(page - 1)}
      >
        <ChevronLeft size="18px" />
      </button>

      <button
        className="pagination-next"
        title={formatMessage({ id: "proxima-pagina" })}
        disabled={page >= totalPages}
        onClick={() => setPage(page + 1)}
      >
        <ChevronRight size="18px" />
      </button>

      <ul className="pagination-list">
        {page > 2 && (
          <li>
            <button className="pagination-link" onClick={() => setPage(1)}>
              1
            </button>
          </li>
        )}
        {page > 3 && (
          <li>
            <button className="pagination-ellipsis">&hellip;</button>
          </li>
        )}
        {page > 1 && (
          <li>
            <button
              className="pagination-link"
              onClick={() => setPage(page - 1)}
            >
              {page - 1}
            </button>
          </li>
        )}
        <li>
          <button className="pagination-link is-current">{page}</button>
        </li>
        {page < totalPages && (
          <li>
            <button
              className="pagination-link"
              onClick={() => setPage(page + 1)}
            >
              {page + 1}
            </button>
          </li>
        )}
        {page < totalPages - 2 && (
          <li>
            <button className="pagination-ellipsis">&hellip;</button>
          </li>
        )}
        {page < totalPages - 1 && (
          <li>
            <button
              className="pagination-link"
              onClick={() => setPage(totalPages)}
            >
              {totalPages}
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Pagination;
